import { extractAxiosData } from '@/common/services/extractAxiosData';
import { PlatformApiFactory } from '@eloomi/eloomi-platforms-external-client/1.0';
import { initClientWithoutAuth } from '../http-client';

const PlatformApiClient = initClientWithoutAuth(PlatformApiFactory);

export async function getPlatformDetails(domain: string) {
    return PlatformApiClient.resolveDomain(domain).then(extractAxiosData);
}
